import { render, staticRenderFns } from "./LossWorkingCase.vue?vue&type=template&id=179f13d8&scoped=true&"
import script from "./LossWorkingCase.vue?vue&type=script&lang=js&"
export * from "./LossWorkingCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f13d8",
  null
  
)

export default component.exports